import { render, staticRenderFns } from "./CustomFormItem.vue?vue&type=template&id=4fa09a5a&scoped=true"
import script from "./CustomFormItem.vue?vue&type=script&lang=js"
export * from "./CustomFormItem.vue?vue&type=script&lang=js"
import style0 from "./CustomFormItem.vue?vue&type=style&index=0&id=4fa09a5a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fa09a5a",
  null
  
)

export default component.exports